import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { SiteLaunchService } from '../../../core/services/site-launch.service';
import { LOGIN_NOTIFICATION_TRANSLATIONS } from './login-notification-modal.translations';

@Component({
  selector: 'app-login-notification-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-notification-modal.component.html',
  styleUrls: ['./login-notification-modal.component.scss'],
})
export class LoginNotificationModalComponent implements OnInit {
  isVisible$: Observable<boolean>;
  currentLang: 'en' | 'or' = 'or';

  constructor(private launchService: SiteLaunchService) {
    this.isVisible$ = this.launchService.loginNotificationVisible$;
  }

  ngOnInit(): void {
    const savedLang = localStorage.getItem('app_lang');
    this.currentLang = savedLang === 'en' ? 'en' : 'or';
  }

  @HostListener('window:langChange', ['$event'])
  onLangChange(event: CustomEvent) {
    this.currentLang = event.detail === 'en' ? 'en' : 'or';
  }

  get t() {
    return LOGIN_NOTIFICATION_TRANSLATIONS[this.currentLang] || LOGIN_NOTIFICATION_TRANSLATIONS['en'];
  }

  closeModal(): void {
    this.launchService.hideLoginNotificationModal();
  }
}
